import React from 'react';

import styles from './logchat.module.css';

import LogChatItem from './logchat_item.component';
import LogChatSidebar from './logchat_sidebar.component';
import ConnectRepoNudge from '../common/connect_repo_nudge.component';

const LogChat = () => {
  return (
    <div className={styles.component}>
      <ConnectRepoNudge message="LogChat will find the cause in your source code and can open a pull request with the fix." />
      <div className={styles.content}>
        <LogChatSidebar />
        <LogChatItem />
      </div>
    </div>
  );
};

export default LogChat;
